// extracted by mini-css-extract-plugin
module.exports = {"componentBBHero":"bb-hero__0mMvh","bb-hero-emergency":"bb-hero-emergency__x283Q"};